// extracted by mini-css-extract-plugin
module.exports = {"ThumnailWrapper":"Video_ThumnailWrapper__3Hz-I","PlayBtn":"Video_PlayBtn__2Q-MO","VideoWrapper":"Video_VideoWrapper__1vKjD"};